// extracted by mini-css-extract-plugin
export default {"root":"DefaultLeftNav_root__IPYyK","root--dark-theme":"DefaultLeftNav_root--dark-theme__zF1vF"};